var __TEMP__ = require('./capitalize.js');var capitalize = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_createCompounder.js');var createCompounder = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = camelCase;
